module.exports = __webpack_public_path__ + "img/icon_line.727b99d0.svg";